export const RECHARGE_REQUEST = 'RECHARGE_REQUEST';
export const ACTIVATION_REQUEST = 'ACTIVATION_REQUEST';
